import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { APIURL } from '../../../config';
import { Chip, CircularProgress, Tooltip } from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

function SyncStatusBadge({ customerId }) {
    const [syncRecord, setSyncRecord] = useState(undefined); // undefined = loading, null = not found

    useEffect(() => {
        if (!customerId) return;
        axios.get(APIURL + `/ah_sync/status/${customerId}`)
            .then(res => setSyncRecord(res.data))
            .catch(() => setSyncRecord(null));
    }, [customerId]);

    if (syncRecord === undefined) return null; // still loading — no flash
    if (!syncRecord) return null;              // no sync record — customer not invited to AH

    if (!syncRecord.consent_given) {
        return (
            <Tooltip title="Customer has been invited to AbilityHub but has not yet accepted sync">
                <Chip
                    icon={<HourglassEmptyIcon />}
                    label="Pending Invite"
                    size="small"
                    variant="outlined"
                    style={{ marginLeft: 8 }}
                />
            </Tooltip>
        );
    }

    if (syncRecord.consent_given && !syncRecord.initial_sync_done) {
        return (
            <Tooltip title="Initial sync in progress">
                <Chip
                    icon={<CircularProgress size={14} />}
                    label="Syncing..."
                    size="small"
                    variant="outlined"
                    style={{ marginLeft: 8 }}
                />
            </Tooltip>
        );
    }

    return (
        <Tooltip title="Health records are syncing bidirectionally with AbilityHub">
            <Chip
                icon={<CheckCircleIcon />}
                label="AbilityHub Sync Active"
                size="small"
                color="success"
                style={{ marginLeft: 8 }}
            />
        </Tooltip>
    );
}

export default SyncStatusBadge;
